import React, { useState } from "react";
import styles from "./recordings.page.module.scss";

const statCards = [
  { label: "Total Recordings", value: "8", tone: "default" },
  { label: "Positive", value: "3", tone: "positive" },
  { label: "Negative", value: "3", tone: "negative" },
  { label: "Mixed/Neutral", value: "2", tone: "neutral" },
];

const recordings = [
  {
    id: "LAG001",
    location: "Calamba, Laguna",
    coordinates: "14.2167, 121.1653",
    date: "3/21/2026",
    time: "2:30 PM",
    demographics: "35-44 - Female - Retail/Trade",
    residing: "Born Here",
    summary:
      "Respondent expressed frustration about poor road conditions, flooding, and lack of street lighting.",
    sentiment: "negative",
    tone: "frustrated",
    concerns: ["Poor road conditions", "Flooding", "Lack of street lighting"],
  },
  {
    id: "LAG002",
    location: "Santa Rosa, Laguna",
    coordinates: "14.3122, 121.1114",
    date: "3/25/2026",
    time: "3:45 PM",
    demographics: "65+ - Male - Retired",
    residing: "Born Here",
    summary:
      "Positive feedback about the new health center and medicine availability for senior citizens.",
    sentiment: "positive",
    tone: "hopeful",
    concerns: ["Healthcare accessibility"],
  },
  {
    id: "LAG003",
    location: "Binan, Laguna",
    coordinates: "14.3386, 121.0867",
    date: "4/2/2026",
    time: "4:20 PM",
    demographics: "35-44 - Female - Domestic",
    residing: "10+ years",
    summary:
      "Mother worried about overcrowded public schools, classroom shortages, and teacher gaps.",
    sentiment: "negative",
    tone: "concerned",
    concerns: ["Overcrowded schools", "Lack of classrooms", "Teacher shortage"],
  },
];

const RecordingsPage = () => {
  const [search, setSearch] = useState("");

  const filtered = recordings.filter((r) => r.id.toLowerCase().includes(search.toLowerCase()));

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1>Survey Recordings</h1>
        <p>Browse and analyze all submitted survey recordings</p>
      </div>

      <section className={styles.statsGrid}>
        {statCards.map((card) => (
          <article key={card.label} className={styles.statCard}>
            <p>{card.label}</p>
            <strong className={styles[card.tone]}>{card.value}</strong>
          </article>
        ))}
      </section>

      <div className={styles.toolbar}>
        <div className={styles.searchBox}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
          <input
            type="text"
            placeholder="Search recording ID..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {search && (
            <button className={styles.clearBtn} onClick={() => setSearch("")}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          )}
        </div>
        <button className={styles.filterBtn}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="4" y1="6" x2="20" y2="6" />
            <line x1="8" y1="12" x2="16" y2="12" />
            <line x1="11" y1="18" x2="13" y2="18" />
          </svg>
          Filters
        </button>
      </div>

      <section className={styles.recordingsList}>
        {filtered.map((item) => (
          <article key={item.id} className={styles.recordingCard}>
            <div className={styles.recordingTop}>
              <div>
                <p className={styles.metaLabel}>Location</p>
                <h3>{item.location}</h3>
                <small>{item.coordinates}</small>
              </div>

              <div>
                <p className={styles.metaLabel}>Date & Campaign</p>
                <p className={styles.inlineMeta}>{item.date}</p>
                <small>{item.time}</small>
                <div className={styles.campaignCode}>{item.id}</div>
              </div>

              <div>
                <p className={styles.metaLabel}>Demographics</p>
                <p className={styles.inlineMeta}>{item.demographics}</p>
                <small>
                  <span>Residing:</span> {item.residing}
                </small>
              </div>

              <div>
                <p className={styles.metaLabel}>Executive Summary</p>
                <p className={styles.summary}>{item.summary}</p>
              </div>

              <div className={styles.sideMeta}>
                <p className={styles.metaLabel}>Sentiment</p>
                <span className={styles[item.sentiment]}>{item.sentiment}</span>
                <small>
                  <span>Tone:</span> {item.tone}
                </small>
              </div>
            </div>

            <div className={styles.concernsRow}>
              <p className={styles.metaLabel}>Key Concerns</p>
              <div>
                {item.concerns.map((concern) => (
                  <span key={concern}>{concern}</span>
                ))}
              </div>
            </div>
          </article>
        ))}
      </section>
    </div>
  );
};

export default RecordingsPage;
